export var ASTERISK = '*';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/internal/htmlConstants.js
// module id = 240
// module chunks = 0